module.exports = __webpack_public_path__ + "img/access-denied.468ecdcd.png";